export default __webpack_public_path__ + "static/2-b89011d048adf7d9a7d7eb9ad12ef039.jpg";